// extracted by mini-css-extract-plugin
export default {"pill":"CountPillGrey_pill__7MARt"};